<script>
    import Versace from 'desktop/icons/brands/Versace.svelte';
    import Gucci from 'general/icons/brands/Gucci.svelte';
    import Prada from 'desktop/icons/brands/Prada.svelte';
    import Coach from 'desktop/icons/brands/Coach.svelte';

    import s from './style.module.css';
</script>

<div class={s.container}>
    <Gucci />
    <Prada />
    <Versace />
    <Coach />
</div>
